/**
 * React Query hook for the Business Profile read (XC-ERP1-U3 §5.3).
 *
 * Keyed by the JWT's tenant (`currentUser.tenantId`), never the overridable
 * `currentTenant`: the gateway reads the JWT's tenant, so a key from anywhere
 * else could file one tenant's profile under another's name.
 */

import { useQuery } from '@tanstack/react-query';

import { useTenantContext } from '@/contexts/TenantContext';
import { fetchBusinessProfile, type BusinessProfileResult } from '@/services/businessProfileService';

export const businessProfileKeys = {
  all: ['businessProfile'] as const,
  tenant: (tenantId: string) => ['businessProfile', tenantId] as const,
};

export function useBusinessProfile() {
  const { currentUser } = useTenantContext();
  const tenantId = currentUser.tenantId;
  return useQuery<BusinessProfileResult>({
    queryKey: businessProfileKeys.tenant(tenantId),
    queryFn: fetchBusinessProfile,
    enabled: !!tenantId,
    staleTime: 60_000,
  });
}
